export default function sanitizeColor(color) {
  if (!color) return "";

  return color.replace(/Monogram/gi, "").trim();
}
